module.exports = __webpack_public_path__ + "img/pr-3.317078b8.png";